export const formatTime = (time: number | undefined): string | void => {
  if (time === 0)
    return "00:00";
  if (!(time) || time < 0)
    return;
  const hours: string | number = Math.floor(time / 3600);
  let minutes: string | number = Math.floor((time % 3600) / 60);
  let seconds: string | number = Math.floor(time % 60);
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${hours > 0 ? `${hours}:` : ""}${minutes}:${seconds}`;
};
